var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0495 3.5481C18.4325 3.5481 18.7437 3.85599 18.7437 4.23484C18.7437 4.6137 18.4325 4.92159 18.0495 4.92159H9.95032C9.56734 4.92159 9.2561 4.6137 9.2561 4.23484C9.2561 3.85599 9.56734 3.5481 9.95032 3.5481H18.0495Z",
    fill: "#001854"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38843 0H26.6116C27.3764 0 28 0.616928 28 1.37349V17.6265C28 18.3831 27.3764 19 26.6116 19H1.38843C0.624793 19 0 18.3808 0 17.6265V1.37349C0 0.618072 0.62595 0 1.38843 0ZM26.6116 1.37349V2.00301C26.6116 2.65657 26.298 2.9862 25.7646 3.37078L14 11.8601C10.1726 9.0994 6.34975 6.33066 2.51884 3.57681C1.82347 3.07777 1.38843 2.7653 1.38843 2.00301V1.37349H26.6116ZM26.6116 16.5998V4.45813C23.7653 6.54699 20.8704 8.59578 18.0056 10.6629L26.6116 16.5998ZM2.31752 17.6265H25.6825L16.8231 11.5156L14.4177 13.2508C14.1817 13.4282 13.8461 13.4408 13.5939 13.2588L11.1769 11.5156L2.31752 17.6265ZM1.38843 4.45813V16.5998L9.99438 10.6629C7.12843 8.59578 4.23587 6.54813 1.38843 4.45813Z",
    fill: "#001854"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.089e7e6bc88eb7dc5f4529c3207a5ad1.svg";
export { ForwardRef as ReactComponent };